<template>
  <el-dialog
    :title="$t('deleteMenuGroup.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div style="text-align:center">
      <p>{{$t('deleteMenuGroup.confirmDeleteMenuGroup')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('deleteMenuGroup.cancel')}}</el-button>
      <el-button type="primary" @click="deleteMenuGroup">{{$t('deleteMenuGroup.confirmDelete')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMenuGroup } from '@/api/dev/menuGroupApi'

export default {
  name: 'DeleteMenuGroup',
  data() {
    return {
      dialogVisible: false,
      deleteMenuGroupInfo: {}
    }
  },
  methods: {
    open(row) {
      this.deleteMenuGroupInfo = { ...row }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteMenuGroupInfo = {}
    },
    async deleteMenuGroup() {
      try {
        await deleteMenuGroup(this.deleteMenuGroupInfo)
        this.$message.success(this.$t('deleteMenuGroup.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error.message || this.$t('deleteMenuGroup.deleteFailed'))
      }
    }
  }
}
</script>